import { render, staticRenderFns } from "./Trader.vue?vue&type=template&id=c258b7bc&scoped=true&"
import script from "./Trader.vue?vue&type=script&lang=js&"
export * from "./Trader.vue?vue&type=script&lang=js&"
import style0 from "./Trader.vue?vue&type=style&index=0&id=c258b7bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c258b7bc",
  null
  
)

export default component.exports